
export default class Helpers {
  static parseInt(value) {
    const intValue = parseFloat(value)
    if (isNaN(intValue)) {
      return 0
    }
    return intValue
  }

  static isNumber(value) {
    return value.match( /^-?\d*\.?\d*$/ )
  }

  static dragArray(array, from, to) {
    const fromItem = array[from];
     if (from < to) {
      array.splice(to + 1, 0, fromItem);
      array.splice(from, 1);
      return array
    }else if (from > to) {
      array.splice(from, 1);
      array.splice(to, 0, fromItem);
    }
    return array
  }
}